export function getPendingImageChanges(imageChanges) {
  return imageChanges.filter(change => change.element)
}

export function serializeViewImages(viewImages, imageChanges) {
  const pendingChanges = getPendingImageChanges(imageChanges)

  return viewImages.map(image => {
    const uploadIndex = pendingChanges.findIndex(change => change.url === image.url)
    if (uploadIndex === -1) return image

    const serializedImage = Object.assign({}, image, {
      pendingUpload: true,
      uploadIndex
    })
    delete serializedImage.url
    delete serializedImage.isNew
    return serializedImage
  })
}

export function getEditPostErrorMessage(error) {
  const responseData = error && error.response && error.response.data
  if (responseData && responseData.message) {
    return responseData.message
  }
  if (typeof responseData === 'string') return responseData
  return error && error.message ? error.message : 'Unable to save changes'
}



// WEBPACK FOOTER //
// ./src/components/views/Post/editPostPayload.js